<template>
  <EmailProviderBinding />
</template>

<script>
import EmailProviderBinding from '../components/templates/EmailProviderBinding'

export default {
  components: {
    EmailProviderBinding
  }
}
</script>
